<template>
  <div class="view-kajabi">
    <div class="mb-6">
      <h5 class="text-semibold">Kajabi</h5>
      <small>Integre sua área de membros da plataforma Kajabi ao ZeusPay</small>
    </div>
    <snow-data-table-header
      @add="add"
      :datePicker="false"
      @searching="searching"
      addText="Adicionar integração"
      :search="false"
      :filters="false"
    />

    <div v-if="loading" class="text-center">
      <b-spinner variant="primary" />
    </div>

    <div v-else>
      <snow-data-table :data="integrationList" :columns="membersColumns">
        <template #no-content-actions>
          <snow-button
            icon="ph ph-plus"
            text="Adicionar integração"
            @click="modal = true"
          />
        </template>
      </snow-data-table>
      <div class="d-flex justify-content-end mt-4">
        <snow-paginator
          v-model="page"
          :pagination="pagination"
          @change-page="dispatch"
        />
      </div>
    </div>

    <integration-modal
      v-model="modal"
      :isEdit="!!integrationToEdit"
      title="Kajabi"
      link="https://kajabi.com/"
    >
      <kajabi-modal
        :integrationToEdit="integrationToEdit"
        @close="modal = false"
        @update-list="dispatch"
      />
    </integration-modal>
  </div>
</template>
<script>
import KajabiModal from "@/components/tools/modals/member-area/Kajabi.vue";
import IntegrationsMixin from "@/mixins/integration";

export default {
  mixins: [IntegrationsMixin],
  components: {
    KajabiModal
  },
  data() {
    return {
      integration: "kajabi",
      breadcrumbs: [
        { title: "Ferramentas", link: "tools" },
        { title: "Área de membros", link: "tools-member-area" },
        { title: "Kajabi" }
      ]
    };
  },
  methods: {
    actions(item) {
      return [
        {
          label: "Editar",
          click: this.edit
        },
        {
          label: "Excluir",
          class: "text-danger",
          variant: "danger",
          dialog: {
            text:
              "Deseja mesmo excluir esta integração? Não enviaremos mais os leads para esta segmentação.",
            icon: "ph ph-trash",
            buttonText: "Sim, excluir",
            action: this.submitDelete,
            secondaryButtonText: "Não, cancelar"
          }
        }
      ];
    }
  },
  computed: {
    membersColumns() {
      return [
        {
          name: "Produto",
          field: "product",
          transform: product => (product ? product.name : "-")
        },
        {
          name: "URL Ativação",
          field: "url_activation"
        },
        {
          name: "URL Desativação",
          field: "url_deactivation"
        },
        {
          name: "Preço",
          field: "offer",
          transform: offer => (offer ? `R$ ${offer.price}` : "Preço padrão")
        },
        {
          type: "menu",
          options: this.actions
        }
      ];
    }
  }
};
</script>
